import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthSplitLayout } from '../../../components/AuthSplitLayout';
import { useToastStore } from '../../../stores/toastStore';
import { useAdminAuth } from '../auth/useAdminAuth';

export function AdminLoginPage(): JSX.Element {
  const { isAdminAuthenticated, adminLogin } = useAdminAuth();
  const navigate = useNavigate();
  const pushToast = useToastStore((s) => s.push);
  const [key, setKey] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isAdminAuthenticated) {
      void navigate('/admin/dashboard', { replace: true });
    }
  }, [isAdminAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await adminLogin(key);
      pushToast({ tone: 'success', title: 'Acceso concedido', description: 'Bienvenido al panel de plataforma.' });
      void navigate('/admin/dashboard', { replace: true });
    } catch {
      setError('Clave de plataforma incorrecta.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthSplitLayout
      badge="Platform"
      title="DocuSense Admin"
      subtitle="Panel de administración de plataforma."
      tagline={
        <>
          Control total de la <span className="brand-text">plataforma</span>.
        </>
      }
    >
      <form onSubmit={(e) => { void handleSubmit(e); }} noValidate>
        <div className="mb-6">
          <label className="label" htmlFor="platform-key">Clave de plataforma</label>
          <input
            id="platform-key"
            type="password"
            autoComplete="current-password"
            className="input"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            disabled={submitting}
          />
          {error !== '' ? <p className="mt-1 text-sm text-danger">{error}</p> : null}
        </div>
        <button type="submit" className="btn-primary w-full" disabled={submitting || key === ''}>
          {submitting ? 'Verificando…' : 'Entrar'}
        </button>
      </form>

      <p className="mt-6 text-xs text-slate-400">
        El token de administrador es válido durante 8 horas y no persiste al refrescar.
      </p>
    </AuthSplitLayout>
  );
}
